export const titleWithIconStyles = (icon) => {
  if (icon) {
    return {
      display: 'inline-block',
      paddingRight: '32px',
      '&::after': {
        content: `'${icon}'`,
        position: 'absolute',
        top: {
          xs: '-5px',
          xl: '0px',
        },
        right: 0,
        fontSize: {
          xs: '24px',
          xl: '19px',
        },
      },
    };
  }
  return {};
};

const styles = {
  item: {
    position: 'relative',
    paddingRight: {
      xl: '16px',
    },
    paddingLeft: {
      xs: '15px',
      xl: 0,
    },
    paddingTop: {
      xl: '23px',
    },
    paddingBottom: {
      xs: '32px',
      xl: 0,
    },
    '&:last-child': {
      marginBottom: 0,
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundColor: 'kit.background.middlepurple',
      top: 0,
      left: 0,
      width: {
        xs: '2px',
        xl: '100%',
      },
      height: {
        xs: '100%',
        xl: '2px',
      },
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      backgroundColor: 'kit.background.purple',
      left: 0,
      top: 0,
      borderRadius: '50%',
      width: {
        xs: '12px',
        xl: '16px',
      },
      height: {
        xs: '12px',
        xl: '16px',
      },
      transform: {
        xs: 'translateX(-50%)',
        xl: 'translateY(-50%)',
      },
    },
    '&:last-child::before': {
      display: 'none',
    },
  },
  title: {
    position: 'relative',
    color: 'kit.text.main',
    minHeight: '50px',
    marginBottom: {
      xs: '4px',
      xl: '12px',
    },
    whiteSpace: {
      xs: 'nowrap',
      xl: 'pre-line',
    },
  },
  description: {
    color: 'kit.text.secondary',
  },
};

export default styles;
